import BottomFixedCTA from '../common/bottomFixedCTA';

type Props = {
    targetId: string;
    withHeader?: boolean;
    hasCardData?: boolean;
};

export const StaticExploreCta: React.FC<Props> = ({
    targetId,
    withHeader = false,
    hasCardData = false,
}) => {
    const scrollToTarget = () => {
        const targetEl: any = document.getElementById(targetId);

        if (withHeader) {
            window.scrollTo({
                top: hasCardData ? 752 : 473,
                behavior: 'smooth',
            });
        } else {
            targetEl?.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <BottomFixedCTA
            ctaName="Explore our offerings"
            webFixed
            onClick={scrollToTarget}
        />
    );
};
